import { useT } from '../i18n'
import { type FavLane, toggleFav, useFavs } from '../lib/personal'

const key = (pol: string, pod: string) => `${pol}-${pod}`.toUpperCase()

/** Star toggle that pins a lane to "Your lanes". Reactive across the app via the personal store. */
export function StarButton({
  lane,
  className = '',
}: { lane: FavLane; className?: string }) {
  const t = useT()
  const favs = useFavs()
  const on = favs.some((f) => key(f.pol, f.pod) === key(lane.pol, lane.pod))
  return (
    <button
      type="button"
      aria-pressed={on}
      aria-label={on ? t('fav.remove') : t('fav.add')}
      title={on ? t('fav.remove') : t('fav.add')}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggleFav(lane)
      }}
      className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
        on ? 'text-signal' : 'text-faint hover:text-signal'
      } ${className}`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={on ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 3.2l2.6 5.5 6 .8-4.4 4.1 1.1 6-5.3-2.9-5.3 2.9 1.1-6L4 9.5l6-.8z" />
      </svg>
    </button>
  )
}
